import { Skeleton } from '@avanta/shared/components/ui/Skeleton';
import { cn } from '@avanta/shared/utils/cn';

interface BubbleConfig {
  align: 'left' | 'right';
  lines: string[];
}

const MESSAGES: BubbleConfig[] = [
  { align: 'left', lines: ['w-28'] },
  { align: 'right', lines: ['w-44'] },
  { align: 'left', lines: ['w-52', 'w-36'] },
  { align: 'right', lines: ['w-24'] },
  { align: 'left', lines: ['w-40'] },
  { align: 'right', lines: ['w-52', 'w-32'] },
  { align: 'left', lines: ['w-32'] },
  { align: 'right', lines: ['w-48'] },
];

export const ConversationSkeleton = (): React.ReactElement => (
  <div className="flex-1 flex flex-col border border-gray-200">
    <div className="flex justify-between items-center p-4 border-b border-gray-200 bg-white sticky top-0 left-0 right-0 z-10">
      <Skeleton className="h-5 w-40" />
      <div className="flex items-center gap-1">
        <Skeleton className="size-8 rounded-md" />
        <Skeleton className="size-8 rounded-md" />
      </div>
    </div>
    <div className="flex flex-col gap-6 p-4 flex-1 overflow-hidden">
      {MESSAGES.map((msg, index) => (
        <div key={index} className={cn('flex', msg.align === 'right' && 'justify-end')}>
          <div
            className={cn(
              'rounded-2xl px-4 py-2',
              msg.align === 'left'
                ? 'rounded-tl-none bg-gray-200/70'
                : 'rounded-tr-none bg-gray-300/50'
            )}
          >
            <div className="flex flex-col gap-1.5">
              {msg.lines.map((width, lineIndex) => (
                <Skeleton key={lineIndex} className={cn('h-4', width)} />
              ))}
              <div className="flex items-center gap-1 mt-1 justify-end">
                <Skeleton className="h-3 w-14" />
                {msg.align === 'right' && <Skeleton className="size-3 rounded-sm" />}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
    <div className="flex items-end gap-0.5 px-4 py-2 border-t border-gray-200 bg-white">
      <Skeleton className="h-9 flex-1 rounded-md bg-transparent" />
      <Skeleton className="size-7 rounded-md shrink-0" />
      <Skeleton className="size-7 rounded-md shrink-0" />
      <Skeleton className="size-7 rounded-md shrink-0" />
    </div>
  </div>
);
